import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';
import '../Workbench.css';
import Announcements from '../components/Announcements';
import Files from '../components/Files';
import EmbeddedVerticalCalendar from '../components/EmbeddedVerticalCalendar';
import { TAB_KEYS } from '../components/Tabs';

const VerticalMainLayout = ({ onNavigateTab }) => {
  const { vertical_id: verticalId } = useParams();
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: '50% 50%',
        gap: 2,
        pb: 4,
      }}
    >
      <Box className="workbench-card" sx={{ gridRow: '1 / 3', overflow: 'hidden' }}>
        <EmbeddedVerticalCalendar
          verticalId={verticalId}
          onOpenVerticalCalendar={() => onNavigateTab?.(TAB_KEYS.CALENDAR)}
        />
      </Box>
      <Box className="workbench-card">
        <Announcements />
      </Box>
      <Box className="workbench-card">
        <Files isVertical={true} verticalId={verticalId} />
      </Box>
    </Box>
  );
};

export default VerticalMainLayout;
